module.exports = __webpack_public_path__ + "img/title-design.326bce69.svg";